(() => {
  'use strict';

  const closeWishlistMenus = (except) => {
    document.querySelectorAll('.lb-wishlist-anchor.is-open').forEach((anchor) => {
      if (anchor === except) return;
      anchor.classList.remove('is-open');
      anchor.classList.remove('is-up');
      anchor.querySelector('[data-lb-wishlist-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  };

  const placeWishlistMenu = (anchor) => {
    anchor.classList.remove('is-up');
    const menu = anchor.matches('[data-lb-wishlist-ready="true"]')
      ? anchor.querySelector(':scope > .Vtl-WishlistButtonWrapper')
      : anchor.querySelector(':scope > .lb-wishlist-fallback');
    if (!menu) return;

    const anchorRect = anchor.getBoundingClientRect();
    const menuHeight = menu.getBoundingClientRect().height || menu.scrollHeight;
    const spaceBelow = window.innerHeight - anchorRect.bottom - 8;
    const spaceAbove = anchorRect.top - 8;
    if (spaceBelow < menuHeight && spaceAbove > spaceBelow) {
      anchor.classList.add('is-up');
    }
  };

  document.addEventListener('click', (event) => {
    const more = event.target.closest('[data-lb-product-family-more]');
    if (more) {
      const family = more.closest('[data-lb-product-family]');
      family?.querySelectorAll('.lb-product-family__item--hidden').forEach((item) => {
        item.classList.remove('lb-product-family__item--hidden');
      });
      more.setAttribute('aria-expanded', 'true');
      more.remove();
      return;
    }

    const toggle = event.target.closest('[data-lb-wishlist-menu-toggle]');
    if (toggle) {
      const anchor = toggle.closest('.lb-wishlist-anchor');
      const open = !anchor.classList.contains('is-open');
      closeWishlistMenus(anchor);
      anchor.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) placeWishlistMenu(anchor);
      else anchor.classList.remove('is-up');
      return;
    }

    const anchor = event.target.closest('.lb-wishlist-anchor');
    if (!anchor) closeWishlistMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeWishlistMenus();
      document.querySelector('[data-lb-wishlist-menu-toggle][aria-expanded="true"]')?.focus();
    }
  });
})();

